import { z } from "zod";
// ===== RESPONSE SCHEMAS =====
export const PayrollExportResponseSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    exportedById: z.uuid(),
    createdAt: z.iso.datetime(),
    confirmed: z.boolean(),
    s3Key: z.string().nullable(),
});
export const ConfirmPayrollExportResponseSchema = z.object({
    confirmedCount: z.number(),
});
export const ExportPayrollCsvResponseSchema = z.object({
    csv: z.string(),
    exportId: z.uuid(),
    s3DownloadUrl: z.string().optional(),
});
